import { render, staticRenderFns } from "./CuratorIO.vue?vue&type=template&id=4730bf5a"
import script from "./CuratorIO.vue?vue&type=script&lang=js"
export * from "./CuratorIO.vue?vue&type=script&lang=js"
import style0 from "./CuratorIO.vue?vue&type=style&index=0&id=4730bf5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports